<template>
	<section class="desc-warp">
		<div class="desc-box">
			<span class="desc one-line" v-for="(item, idx) in Contents" :key="idx">{{item.Content}}</span>
		</div>
	</section>
</template>

<script>
export default {
	name: 'DoubleDesc',
	props: ['Contents'],
}
</script>

<style lang="scss" scoped>
.desc-warp {
	display: -webkit-box;
	-webkit-box-pack: justify;
}
.desc-box {
	-webkit-box-flex: 1;
	display: block;
}
.desc {
	display: block;
	margin-bottom: 7px;
	font-size: 13px;
	color: #666;
}
.desc:last-child {
	margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/template/desc/DoubleDesc.vue